// extracted by mini-css-extract-plugin
module.exports = {"container":"HotelOffset_container__2FzUS","title":"HotelOffset_title__1xtv-","button":"HotelOffset_button__pJvsm","table":"HotelOffset_table__3TppZ"};